import type SharedViewState from '../store/schema/SharedViewState';
import createEmptyRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createEmptyRecipientWell';
import type ServicesRequestStatus from '../store/schema/ServicesRequestStatus';
import type LinkAccessType from '../store/schema/LinkAccessType';
import { bookWithMeShareLinkByEmailBody } from '../components/shared/ShareLinkStrings.locstring.json';
import loc from 'owa-localize';

export default function (): SharedViewState {
    return {
        shareEventId: '',
        shareEventTitle: '',
        shareMessage: loc(bookWithMeShareLinkByEmailBody),
        shareTheme: '',
        shareMeetingTypeDuration: '',
        shareMeetingDescription: '',
        shareRecipients: createEmptyRecipientWell(),
        shareLink: '',
        createLinkStatus: 0,
        isSingleUse: false,
        isAttendeeAuthRequired: false,
        allowedAttendees: [],
        isPrivate: false,
        linkAccessType: 0,
        invalidAccessAttendees: [],
        noAttendeeWarning: false,
        showShareModal: false,
    };
}
